import Swiper, {Navigation, Lazy, Keyboard, A11y, EffectCoverflow, Autoplay} from 'swiper';

Swiper.use([Navigation, Lazy, Keyboard, A11y, EffectCoverflow, Autoplay]);

const initSliders = () => {

    if (document.querySelectorAll('.ume-slider-wrapper').length > 0) {

        const galleries = document.querySelectorAll('.ume-slider-wrapper');
        galleries.forEach(gallery => {
            const auto = gallery.getAttribute('data-autoplay');
            const swiperContainer = gallery.querySelector('.swiper-container');
            const random = gallery.getAttribute('data-random');
            const slides = gallery.getAttribute('data-slides');
            const countSlides = gallery.querySelectorAll('.swiper-slide');
            const swiperWrapper = gallery.querySelector('.swiper-wrapper');

            let desktop = 1;
            let tablet = 1;
            if (slides !== '') {
                desktop = 3;
                tablet = 2;
            }
            if(swiperWrapper.classList.contains('is-gallery-slider')){
                desktop = slides;
                tablet = Math.ceil(slides / 2) < 5 ? Math.ceil(slides / 2) : 2;
            }
            swiperContainer.setAttribute('data-desktop', desktop);
            swiperContainer.setAttribute('data-tablet', tablet);
            const prevSlide = gallery.querySelector('.swiper-button-prev');
            const nextSlide = gallery.querySelector('.swiper-button-next');
            if (auto === 'autoplay') {
                const newSlider = new Swiper(swiperContainer, {
                    direction: 'horizontal',
                    grabCursor: 'true',
                    initialSlide: `${random !== '' ? Math.floor(Math.random() * (countSlides.length + 1)) : 0}`,
                    speed: 600,
                    loop: swiperContainer.getAttribute('data-loop'),
                    slidesPerView: 1,
                    autoplay: {
                        delay: swiperContainer.getAttribute('data-delay'),
                        disableOnInteraction: true,
                    },
                    breakpoints: {

                        1268: {
                            slidesPerView: swiperContainer.getAttribute('data-desktop'),
                            spaceBetween: 16,
                        },
                        780: {
                            slidesPerView: swiperContainer.getAttribute('data-tablet'),
                            spaceBetween: 16,
                        },


                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: false,
                    },
                    a11y: {
                        prevSlideMessage: 'Zurück',
                        nextSlideMessage: 'Weiter'
                    },
                    centeredSlides: false,

                    navigation: {
                        nextEl: nextSlide,
                        prevEl: prevSlide,
                    },

                });
            } else {
                const newSlider = new Swiper(swiperContainer, {
                    direction: 'horizontal',
                    grabCursor: 'true',
                    speed: 600,
                    initialSlide: `${random !== '' ? Math.floor(Math.random() * (countSlides.length + 1)) : 0}`,
                    loop: swiperContainer.getAttribute('data-loop'),
                    slidesPerView: 1,
                    breakpoints: {

                        1268: {
                            slidesPerView: swiperContainer.getAttribute('data-desktop'),
                            spaceBetween: 16,
                        },
                        780: {
                            slidesPerView: swiperContainer.getAttribute('data-tablet'),
                            spaceBetween: 16,
                        },


                    },

                    keyboard: {
                        enabled: true,
                        onlyInViewport: false,
                    },
                    a11y: {
                        prevSlideMessage: 'Zurück',
                        nextSlideMessage: 'Weiter'
                    },
                    centeredSlides: false,

                    navigation: {
                        nextEl: nextSlide,
                        prevEl: prevSlide,
                    },

                });
            }


        });
    }
}

export default initSliders;